var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Archive component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconAlignRight extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#3F3F3F">
          <path
            aria-hidden="${!this.iconTitle}"
            aria-label="${ifDefined(this.iconTitle)}"
            role="${this.iconTitle && 'img'}"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.07265 1.65785C1.90345 1.72292 1.72021 1.90983 1.65423 2.08467C1.58804 2.26006 1.59788 2.52934 1.67602 2.68129C1.78973 2.90235 1.97086 3.04383 2.20304 3.09303C2.38477 3.1315 21.615 3.1315 21.7967 3.09303C22.0289 3.04383 22.21 2.90235 22.3237 2.68129C22.4018 2.52934 22.4117 2.26006 22.3455 2.08467C22.2777 1.90513 22.0963 1.72256 21.9202 1.65665C21.7902 1.608 21.7801 1.60796 11.9929 1.60921C2.29741 1.61045 2.19459 1.61096 2.07265 1.65785ZM7.06736 6.43167C6.82229 6.46769 6.61894 6.61726 6.50499 6.84528C6.44276 6.96982 6.43186 7.01876 6.43189 7.1738C6.43191 7.56015 6.67863 7.8548 7.05586 7.91902C7.16816 7.93815 9.25597 7.94367 14.5079 7.93877L21.8039 7.93196L21.937 7.86953C22.2243 7.73477 22.3697 7.52624 22.3865 7.22487C22.3994 6.99221 22.3372 6.8149 22.1891 6.66253C22.0581 6.52774 21.9347 6.4646 21.7408 6.43313C21.5628 6.40426 7.26351 6.40282 7.06736 6.43167ZM11.8782 11.256C11.3918 11.3392 11.1141 11.8581 11.3157 12.3073C11.3952 12.4844 11.5131 12.6015 11.6999 12.6887L11.8439 12.756H16.8244H21.8049L21.9657 12.6768C22.1288 12.5965 22.2428 12.4838 22.3349 12.312C22.3698 12.2467 22.3799 12.177 22.3799 12C22.3799 11.8229 22.3698 11.7532 22.3349 11.688C22.2428 11.5161 22.1288 11.4034 21.9657 11.3232L21.8049 11.244L16.8964 11.2406C14.1967 11.2387 11.9385 11.2457 11.8782 11.256ZM7.00786 16.0889C6.65969 16.1659 6.43258 16.4567 6.4321 16.8261C6.43189 16.9818 6.44261 17.0298 6.50569 17.156C6.62091 17.3866 6.81236 17.5229 7.08267 17.5667C7.29565 17.6013 21.5278 17.6013 21.7408 17.5668C21.9347 17.5353 22.0581 17.4722 22.1891 17.3374C22.3372 17.185 22.3994 17.0077 22.3865 16.775C22.3697 16.4737 22.2243 16.2651 21.937 16.1304L21.8039 16.068L14.4719 16.0639C8.79128 16.0607 7.11013 16.0663 7.00786 16.0889ZM2.17186 20.9135C1.84743 20.9932 1.63333 21.2564 1.61353 21.6C1.60529 21.7432 1.6136 21.8076 1.65423 21.9152C1.72198 22.0948 1.90337 22.2774 2.07949 22.3433C2.20952 22.3919 2.22116 22.392 11.9999 22.392C21.7786 22.392 21.7902 22.3919 21.9202 22.3433C22.0963 22.2774 22.2777 22.0948 22.3455 21.9152C22.4117 21.7399 22.4018 21.4706 22.3237 21.3186C22.21 21.0976 22.0289 20.9561 21.7967 20.9069C21.6044 20.8662 2.33816 20.8727 2.17186 20.9135Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconAlignRight.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconAlignRight.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconAlignRight.prototype, "size", void 0);
if (customElements.get('cat-icon-align-right') === undefined) {
    customElements.define('cat-icon-align-right', BlocksIconAlignRight);
}
